'use strict';

var agent_browser = function agent_browser() {};

module.exports = agent_browser;